import React from 'react'
import { Empty } from 'antd'

import './index.module.less'

const MyEmpty = ({ text = '暂无数据' }) => {
  return (
    <div styleName="container">
      <Empty description={text} />
    </div>
  )
}
export default MyEmpty
